import React, { useState, useEffect } from 'react';
import { Button } from "../components/ui/button.jsx";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card.jsx";

const steps = [
  {
    title: "Welcome to ESGrity.AI",
    content: "This demo will guide you through our AI-powered ESG optimization platform. Click 'Next' to begin.",
    target: null,
  },
  {
    title: "Dashboard Overview",
    content: "Here's your main dashboard. It provides a quick overview of your company's ESG performance.",
    target: ".dashboard-overview",
  },
  {
    title: "AI-Powered Predictions and Insights",
    content: "Our AI analyzes your data to provide predictions on your future ESG score, carbon reduction targets, and top ESG risks to address.",
    target: ".dashboard-ai-predictions",
  },
  {
    title: "Key Metrics",
    content: "These cards show your current ESG Score, Carbon Emissions, Diversity Score, and Governance Rating at a glance.",
    target: ".key-metrics",
  },
  {
    title: "ESG Performance Overview",
    content: "This radar chart gives you a visual representation of your Environmental, Social, and Governance scores.",
    target: ".esg-performance-chart",
  },
  {
    title: "Carbon Emissions Trend",
    content: "Track your carbon emissions over time with this line chart.",
    target: ".carbon-emissions-chart",
  },
  {
    title: "Workforce Diversity",
    content: "This chart provides a breakdown of diversity across different groups in your workforce.",
    target: ".workforce-diversity-chart",
  },
  {
    title: "AI Insights",
    content: "Our AI continuously analyzes your data to provide actionable insights and recommendations.",
    target: ".ai-insights",
  },
  {
    title: "AI Chatbot",
    content: "Use our AI chatbot to ask questions about your ESG performance or get recommendations.",
    target: ".ai-chatbot",
  },
  {
    title: "Demo Complete",
    content: "You've seen the key features of ESGrity.AI. Feel free to explore the platform further on your own!",
    target: null,
  },
];

const DemoGuide = ({ onClose }) => {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    document.body.classList.add('dimmed');
    return () => {
      document.body.classList.remove('dimmed');
    };
  }, []);

  useEffect(() => {
    const target = steps[currentStep].target;
    if (target) {
      const element = document.querySelector(target);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        element.classList.add('highlight');
      }
    }
    return () => {
      if (target) {
        const element = document.querySelector(target);
        if (element) {
          element.classList.remove('highlight');
        }
      }
    };
  }, [currentStep]);

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      onClose();
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>{steps[currentStep].title}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="mb-4">{steps[currentStep].content}</p>
          <div className="flex justify-between">
            <Button onClick={prevStep} disabled={currentStep === 0}>Previous</Button>
            <Button onClick={nextStep}>
              {currentStep === steps.length - 1 ? "Finish" : "Next"}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default DemoGuide;